<script setup lang="ts">
import { defineProps } from 'vue'
import FormInput from '@/components/Interface/Modal/Forms/FormInput.vue'

defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    required: true,
  },
  placeHolder: {
    type: String,
    default: '',
  },
  width: {
    type: String,
    default: '20',
  }
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (value: string) => {
  emit('update:modelValue', value);
};

</script>

<template>
  <div class="flex">
    <div v-if="name!=''" class="bg-metal-900 text-metal-300 flex items-center px-2 pt-0 mt-0 rounded-s">{{ name }}</div>
    <div class="bg-metal-900 text-metal-300 px-2 flex items-center rounded-e">
      <FormInput
        :modelValue="modelValue"
        @update:modelValue="updateValue($event as string)"
        :placeholder="placeHolder"
        :class="'w-' + width"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>